import 'firebase/database';
import 'firebase/auth';
import firebase from 'firebase/app';


// GET CONTRACTS
export const GET_ALL_SEGMENTS_PENDING = 'GET_ALL_SEGMENTS_PENDING';
export const GET_ALL_SEGMENTS_FULFILLED = 'GET_ALL_SEGMENTS_FULFILLED';
export const GET_ALL_SEGMENTS_REJECTED = 'GET_ALL_SEGMENTS_REJECTED';

export const GET_SEGMENT_PENDING = 'GET_SEGMENT_PENDING';
export const GET_SEGMENT_FULFILLED = 'GET_SEGMENT_FULFILLED';
export const GET_SEGMENT_REJECTED = 'GET_SEGMENT_REJECTED';

export const GET_SEGMENTS_PENDING = 'GET_SEGMENTS_PENDING';
export const GET_SEGMENTS_FULFILLED = 'GET_SEGMENTS_FULFILLED';
export const GET_SEGMENTS_REJECTED = 'GET_SEGMENTS_REJECTED';

export const DELETE_SEGMENT_PENDING = 'DELETE_SEGMENT_PENDING';
export const DELETE_SEGMENT_FULFILLED = 'DELETE_SEGMENT_FULFILLED';
export const DELETE_SEGMENT_REJECTED = 'DELETE_SEGMENT_REJECTED';

export const CREATE_SEGMENT_PENDING = 'CREATE_SEGMENT_PENDING';
export const CREATE_SEGMENT_FULFILLED = 'CREATE_SEGMENT_FULFILLED';
export const CREATE_SEGMENT_REJECTED = 'CREATE_SEGMENT_REJECTED';

export const ADD_EQUIPMENT_TO_SEGMENT_PENDING = 'ADD_EQUIPMENT_TO_SEGMENT_PENDING';
export const ADD_EQUIPMENT_TO_SEGMENT_FULFILLED = 'ADD_EQUIPMENT_TO_SEGMENT_FULFILLED';
export const ADD_EQUIPMENT_TO_SEGMENT_REJECTED = 'ADD_EQUIPMENT_TO_SEGMENT_REJECTED';

export const REMOVE_EQUIPMENT_FROM_SEGMENT_PENDING = 'REMOVE_EQUIPMENT_FROM_SEGMENT_PENDING';
export const REMOVE_EQUIPMENT_FROM_SEGMENT_FULFILLED = 'REMOVE_EQUIPMENT_FROM_SEGMENT_FULFILLED';
export const REMOVE_EQUIPMENT_FROM_SEGMENT_REJECTED = 'REMOVE_EQUIPMENT_FROM_SEGMENT_REJECTED';

export const ADD_PRODUCT_TO_SEGMENT_PENDING = 'ADD_PRODUCT_TO_SEGMENT_PENDING';
export const ADD_PRODUCT_TO_SEGMENT_FULFILLED = 'ADD_PRODUCT_TO_SEGMENT_FULFILLED';
export const ADD_PRODUCT_TO_SEGMENT_REJECTED = 'ADD_PRODUCT_TO_SEGMENT_REJECTED';

export const REMOVE_PRODUCT_FROM_SEGMENT_PENDING = 'REMOVE_PRODUCT_FROM_SEGMENT_PENDING';
export const REMOVE_PRODUCT_FROM_SEGMENT_FULFILLED = 'REMOVE_PRODUCT_FROM_SEGMENT_FULFILLED';
export const REMOVE_PRODUCT_FROM_SEGMENT_REJECTED = 'REMOVE_PRODUCT_FROM_SEGMENT_REJECTED';

const getAllSegments = () => (dispatch) => {
    dispatch({
        type: GET_ALL_SEGMENTS_PENDING
    }); 

    firebase.database().ref('/segments/').child(localStorage.getItem('companyID')).once('value').then(snapshot => {

        var segmentsWithID = [];
        const segments = snapshot.val();
        if (segments != undefined && segments != null) {
            segmentsWithID = Object.keys(segments).map((segmentId) => { 
                let segment = segments[segmentId];
                segment['id'] = segmentId;
                return segment;
            });
        }

        dispatch({
            type: GET_ALL_SEGMENTS_FULFILLED,
            payload: segmentsWithID
        });
    });
};

const getSegments = (segmentIds) => (dispatch) => {
    dispatch({
        type: GET_SEGMENTS_PENDING
    }); 
    
    let segmentsForEquipment = [];
    let retrievedCount = 0;
    if (segmentIds == undefined) {
        dispatch({
            type: GET_SEGMENTS_FULFILLED,
            payload: segmentsForEquipment
        });
    } else {
        segmentIds.forEach(function(segmentID) {
            firebase.database().ref('/segments/' + localStorage.getItem('companyID') + '/'+ segmentID).once('value').then(snapshot => {
                const segment = snapshot.val();
                if(segment != undefined) {
                    segment.id = segmentID;
                    segmentsForEquipment.push(segment);
                }
                
                retrievedCount++;
                
                if(retrievedCount == Object.keys(segmentIds).length) {
                    dispatch({
                        type: GET_SEGMENTS_FULFILLED,
                        payload: segmentsForEquipment
                    });
                }
            });
        });
    }
};

const getSegment = (segmentID) => (dispatch) => {
    dispatch({
        type: GET_SEGMENT_PENDING
    }); 

    firebase.database().ref('/segments/' + localStorage.getItem('companyID') + '/' + segmentID).once('value').then(snapshot => {
        let segment = snapshot.val();
        segment.id = segmentID;
        dispatch({
            type: GET_SEGMENT_FULFILLED,
            payload: segment
        });
    });

};

const deleteSegment = (segmentId) =>  (dispatch) => {
    dispatch({
        type: DELETE_SEGMENT_PENDING
    });
    
    firebase.database().ref('segments').child(localStorage.getItem('companyID')).child(segmentId).set(null);

    firebase.database().ref('equipment').child(localStorage.getItem('companyID')).once('value', snapshot => {
        
        let equipment = snapshot.val();
        var updates = {};
        
        if (equipment != undefined){
            var equipmentKeys = Object.keys(equipment);
            for (const key of equipmentKeys) {
                updates['/equipment/' + localStorage.getItem('companyID') + '/' + key + '/segments/' + segmentId] = null;
            }
            firebase.database().ref().update(updates);
        }
    });

    firebase.database().ref('products').child(localStorage.getItem('companyID')).once('value', snapshot => {
        
        let equipment = snapshot.val();
        var updates = {};
        
        if (equipment != undefined){
            var equipmentKeys = Object.keys(equipment);
            for (const key of equipmentKeys) {
                updates['/products/' + localStorage.getItem('companyID') + '/' + key + '/segments/' + segmentId] = null;
            }
            firebase.database().ref().update(updates);
        }
    });

    dispatch({
        type: DELETE_SEGMENT_FULFILLED,
        payload: segmentId,
    });
};

const createSegment = (segmentName, segmentColor, segmentIcon) =>  (dispatch) => {
    dispatch({
        type: CREATE_SEGMENT_PENDING
    });
    var newPostKey = firebase.database().ref().child('segments').child(localStorage.getItem('companyID')).push().key;
    var updates = {};
    updates['/segments/' + localStorage.getItem('companyID') + '/' + newPostKey] = {
        'name': segmentName,
        'color': segmentColor,
        'image': segmentIcon
    };

    firebase.database().ref().update(updates);

    dispatch({
        type: CREATE_SEGMENT_FULFILLED,
    });
};

const removeEquipmentFromSegment = (segmentId, equipmentId) => (dispatch) => {

    dispatch({
        type: REMOVE_EQUIPMENT_FROM_SEGMENT_PENDING
    }); 
 
    firebase.database().ref('segments').child(localStorage.getItem('companyID')).child(segmentId).child('equipment').child(equipmentId).set(null);

    dispatch({
        type: REMOVE_EQUIPMENT_FROM_SEGMENT_FULFILLED,
        payload: {
            equipmentId: equipmentId,
            segmentId: segmentId
        }
    }); 
};

const addEquipmentToSegment = (segmentIds, equipmentIds) => dispatch => {
    dispatch({
        type: ADD_EQUIPMENT_TO_SEGMENT_PENDING
    }); 

    for(let segmentID of segmentIds) {
        for(let itemID of equipmentIds) {
            firebase.database().ref('segments/' + localStorage.getItem('companyID') + '/' + segmentID + '/equipment/' + itemID).set(true);
        }
    }
    dispatch({
        type: ADD_EQUIPMENT_TO_SEGMENT_FULFILLED,
        payload: equipmentIds
    }); 
};

const removeProductFromSegment = (segmentId, productID) => (dispatch) => {

    dispatch({
        type: REMOVE_PRODUCT_FROM_SEGMENT_PENDING
    }); 
 
    firebase.database().ref('segments').child(localStorage.getItem('companyID')).child(segmentId).child('products').child(productID).set(null);

    dispatch({
        type: REMOVE_PRODUCT_FROM_SEGMENT_FULFILLED,
        payload: {
            equipmentId: productID,
            segmentId: segmentId
        }
    }); 
};

const addProductToSegment = (segmentIds, productIds) => dispatch => {
    dispatch({
        type: ADD_PRODUCT_TO_SEGMENT_PENDING
    }); 

    for(let segmentID of segmentIds){
        for(let itemID of productIds) {
            firebase.database().ref('segments/' + localStorage.getItem('companyID') + '/' + segmentID + '/products/' + itemID).set(true);
        }
    }

    dispatch({
        type: ADD_PRODUCT_TO_SEGMENT_FULFILLED,
        payload: productIds
    }); 
};

export { getAllSegments, getSegments, getSegment , deleteSegment, createSegment, removeEquipmentFromSegment, addEquipmentToSegment, removeProductFromSegment, addProductToSegment };


// WEBPACK FOOTER //
// ./src/components/state/actions/SegmentActions.js